<div id="codelistCard" class="control-card-white">
    <div class="control-card-header">
        <ng-container i18n="@@view_request_type_title">Tipologia di permesso</ng-container>
        <fa-icon icon="times" class="float-right margin-right-20 icon-clickable" (click)="closeDialog()"></fa-icon>
    </div>

    <div class="control-card-content" id="cardContent">

        <table class="simple-table">
            <tr>
                <td height="80px" class="text-dark td-title" i18n="@@view_request_type_permission_name">Nome
                    del permesso</td>
                <ng-container *ngIf="!wasCreated">
                    <td>
                        <input [(ngModel)]="name" />
                    </td>
                </ng-container>
                <ng-container *ngIf="wasCreated">
                    <td height="40px">
                        <label class="td-label">{{name}}</label>
                    </td>
                </ng-container>
            </tr>
        </table>

<!-- 
        <td width="180px" class="text-dark" i18n="@@useradd_name">Nome</td>
        <ng-container *ngIf="canUserEdit">
            <td>
                <input id="name-input" formControlName="name" [(ngModel)]="username" />
            </td>
        </ng-container>
        <ng-container *ngIf="!canUserEdit">
            <td height="80px">
                <label class="td-label">{{username}}</label>
            </td>
        </ng-container> -->


        <br>
        <br>

        <label  id="files-requested" class="text-dark td-title" i18n="@@view_request_type_requested_files">File necessari per inviare una richiesta:</label>

        <br>
        <br>


        <div class="table-container">
            <div class="scrollable-wrapper">
                <table class="simple-table">
<!-- 
                    <thead>
                        <th></th>
                        <th></th>
                    </thead> -->

                    <tbody>
                        <tr *ngFor="let type of types; index as i; trackBy: trackByIndex">

                            <ng-container *ngIf="!wasCreated">
                                <td>
                                    <input type="text" name="type{{i}}" [(ngModel)]="types[i]" placeholder="{{inputHint}}" />
                                </td>
                            </ng-container>

                            <ng-container *ngIf="wasCreated">
                                <ng-container *ngIf="types?.length === 1 && types[0] === ''">
                                        <td height="60px">
                                            <label class="td-label" i18n="@@view_request_type_no_requested_files" >Nessun file richiesto</label>
                                        </td>
                                </ng-container>

                                <ng-container *ngIf="types?.length > 0 && types[0] !== ''">
                                    <td height="60px">
                                        <label class="td-label" name="type{{i}}">{{types[i]}}</label>
                                    </td>
                                </ng-container>
                            </ng-container>



                            <td *ngIf="!wasCreated">
                                <div class="io-table-buttons">
                                    <fa-icon icon="minus-circle" class="icon-clickable" (click)="deleteItem(i)">
                                    </fa-icon>
                                </div>
                            </td>
                        </tr>
                    </tbody>

                    <tr *ngIf="!wasCreated">
                        <td colspan="4">
                            <div class="io-table-buttons">
                                <fa-icon icon="plus-circle" class="icon-clickable" (click)="createNewType()">
                                </fa-icon>
                            </div>
                        </td>
                    </tr>
                </table>
            </div>
        </div>

        <br>


        <p class="text-small text-error margin-top-10 display-inline" *ngIf="nameError"
            i18n="@@view_request_type_name_error">
            Inserire il nome della tipologia di permesso
        </p>

        <p class="text-small text-error margin-top-10 display-inline" *ngIf="typeNameError"
            i18n="@@view_request_type_type_error">
            Inserire il nome di ciascun file richiesto
        </p>

        <br>
        <br>

        <a *ngIf="!wasCreated" (click)="saveType()" class="button user-add-button">
            <ng-container i18n="@@view_request_type_add">Aggiungi</ng-container>
            <span>
                <fa-icon icon="save"></fa-icon>
            </span>
        </a>

        <a *ngIf="wasCreated" (click)="deleteType()" class="button button-red" id="deleteButton">
            <ng-container i18n="@@view_request_type_delete">Elimina</ng-container>
            <span>
                <fa-icon icon="times"></fa-icon>
            </span>
        </a>

    </div>

    <app-loading-screen #typesloader [loading]="false"></app-loading-screen>
</div>